import React, { ChangeEvent, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { InitialState } from './types'
import * as actions from './actions'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import { useAlert } from 'react-alert'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'

export default () => {
  const [title, setTitle] = useState<string>('')
  const [status, setStatus] = useState<string>('active')
  const [startsAt, setStartsAt] = useState<Date>(new Date())
  const [autoJoin, setAutoJoin] = useState<boolean>(false)

  const dispatch = useDispatch()
  const alert = useAlert()

  useEffect(() => {
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  const { isProcess, error } = useSelector(
    (state: { adminCourseCreate: InitialState }) => state.adminCourseCreate
  )

  useEffect(() => {
    if (error) {
      alert.error(error)
    }
  }, [error])

  const onChangeTitle = (event: ChangeEvent<HTMLInputElement>) => {
    setTitle(event.currentTarget.value)
  }

  const onChangeStatus = (event: ChangeEvent<HTMLSelectElement>) => {
    setStatus(event.currentTarget.value)
  }

  const onChangeAutoJoin = (event: ChangeEvent<HTMLInputElement>) => {
    setAutoJoin(event.currentTarget.checked)
  }

  const handleCreateCourse = () => {
    dispatch(actions.createCourse(title, status, moment(startsAt), autoJoin))
  }

  return (
    <>
      <Header />
      <div className={'container'}>
        <h2>Панель администрирования - Создать курс</h2>
        <label htmlFor={'title'}>Название курса:</label>
        <br />
        <input
          id={'title'}
          placeholder={'Введите название курса'}
          value={title}
          onChange={onChangeTitle}
          style={{ marginBottom: 10, width: 200 }}
          required={true}
          autoComplete={'off'}
        />
        <br />
        <label htmlFor={'status'}>Выберите статус:</label>
        <br />
        <select
          id={'status'}
          value={status}
          style={{ marginBottom: 10, width: 200 }}
          onChange={onChangeStatus}
        >
          <option value={'active'}>Активен</option>
          <option value={'inactive'}>Не активен</option>
        </select>
        <br />
        <label htmlFor={'date'}>Дата начала:</label>
        <br />
        <DatePicker
          locale={'ru'}
          selected={startsAt}
          onChange={(date: Date) => setStartsAt(date)}
          showTimeSelect={true}
          dateFormat={'Pp'}
        />
        <label style={{ display: 'block', margin: '10px 0' }}>
          <input
            checked={autoJoin}
            type={'checkbox'}
            onChange={onChangeAutoJoin}
          />{' '}
          Автоматически подписывать нового пользователя на курс
        </label>
        <button onClick={handleCreateCourse}>Создать курс</button>
        <br />
        <br />
        {isProcess ? <span>Создание курса...</span> : null}
        <br />
        {error ? <span style={{ color: 'red' }}>{error}</span> : null}
      </div>
      <Footer />
    </>
  )
}
